<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       width="100%" viewBox="0 0 171 143" enable-background="new 0 0 171 143" xml:space="preserve">
<path :fill="fillColor" opacity="1.000000" stroke="none"
      d="
M112.000000,1.000000
	C114.370560,1.000000 116.741112,1.000000 119.327393,1.325698
	C125.634590,5.420963 131.670273,9.284656 137.831177,12.937124
	C146.201843,17.899626 154.668274,22.700602 162.932098,27.477488
	C162.786713,28.185583 162.806549,28.428131 162.716415,28.480154
	C138.666077,42.362617 114.567482,56.162445 90.598846,70.184418
	C87.402687,72.054214 85.032661,71.781265 82.072235,70.057114
	C63.015465,58.958458 43.878864,47.996960 24.801807,36.932957
	C19.832321,34.050831 14.981276,30.964487 9.610709,27.688190
	C22.514732,20.380049 34.647320,13.622249 46.638363,6.621985
	C49.035843,5.222359 50.893456,2.897978 53.000000,1.000000
	C55.370556,1.000000 57.741116,1.000000 60.334389,1.332407
	C68.117348,6.127062 75.702652,10.547675 83.223183,15.075875
	C85.607750,16.511656 87.433617,16.930542 90.147369,15.110153
	C95.276802,11.669317 100.962158,9.069322 106.264427,5.868039
	C108.383530,4.588612 110.100159,2.642586 112.000000,1.000000
z"/>
    <path :fill="fontColor" opacity="1.000000" stroke="none"
          d="
M88.006821,140.836121
	C87.557579,140.881454 87.108330,140.926758 86.156967,140.602188
	C80.678802,137.470383 75.659058,134.783905 70.734718,131.932693
	C54.527847,122.548874 38.408524,113.012466 22.142849,103.732246
	C15.974645,100.213043 9.499887,97.231148 3.164855,94.004349
	C3.117714,75.643532 3.070572,57.282719 3.094360,38.459164
	C11.557044,42.613873 20.016928,47.112442 28.325991,51.874187
	C44.292858,61.024456 60.521313,69.788033 75.949272,79.780426
	C84.043510,85.022903 89.740540,84.294609 97.715927,79.374908
	C120.709557,65.191032 144.403442,52.142273 167.824921,38.652275
	C168.240891,38.412697 168.689865,38.230476 169.479065,38.008961
	C169.881851,56.356281 169.929001,74.716141 169.535400,93.539871
	C168.019562,94.345879 166.840302,94.507034 165.884689,95.056870
	C146.811371,106.031151 127.732780,116.997017 108.727371,128.088150
	C101.725342,132.174377 94.908257,136.577530 88.006821,140.836121
z"/>
</svg>
</template>

<script>
export default {
  name: 'MainLogo',
  props: {
    fillColor: {
      type: String,
    },
    fontColor: {
      type: String,
      default: '#000'
    }
  }
}
</script>
